import "core-js/es6/map";
import "core-js/es6/set";
import "promise-polyfill/src/polyfill";
import { dequeue } from "./api";

dequeue();
